/**
 * usePreferStaticUI — skip entrance loops, scroll reveals, and ambient FX.
 *
 * True when the user prefers reduced motion OR the viewport is mobile.
 */
import { useReducedMotion } from "framer-motion";
import useIsMobile from "./useIsMobile";

export const usePreferStaticUI = () => {
  const reduced = useReducedMotion();
  const mobile = useIsMobile();
  return reduced || mobile;
};

export default usePreferStaticUI;
